module.exports = __webpack_public_path__ + "static/media/3_col_2.facc4a5e.jpg";